module.exports = __webpack_public_path__ + "img/close.5a134cda.svg";